// /lib/gtag.js
let gaLoaded = false;

function ensureDL() {
    if (!window.dataLayer) window.dataLayer = [];
    if (!window.gtag) window.gtag = function(){ window.dataLayer.push(arguments); };
}

// Ustawiamy domyślnie DENIED, aby NIC nie poleciało bez opt-in
export function bootstrapConsentDefaults() {
    ensureDL();
    window.gtag('consent', 'default', {
        ad_storage: 'denied',
        analytics_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        functionality_storage: 'granted',
        security_storage: 'granted'
    });
}

function loadScriptOnce(src) {
    return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) return resolve();
        const s = document.createElement('script');
        s.async = true;
        s.src = src;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
    });
}

export async function enableGA(measurementId) {
    if (!measurementId) return;
    ensureDL();
    if (!gaLoaded) {
        await loadScriptOnce(`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`);
        gaLoaded = true;
    }
    window.gtag('js', new Date());
    window.gtag('config', measurementId, { anonymize_ip: true });
}

// Mapowanie naszych kategorii -> Consent Mode
export function applyConsentToGtag(prefs) {
    ensureDL();
    window.gtag('consent', 'update', {
        analytics_storage: prefs.analytic ? 'granted' : 'denied',
        ad_storage: (prefs.advertisement || prefs.personalization) ? 'granted' : 'denied',
        ad_user_data: prefs.advertisement ? 'granted' : 'denied',
        ad_personalization: prefs.personalization ? 'granted' : 'denied'
    });
}
